/*
 * @描述: 首页
 * @版本: 1.0
 * @作者: 冯强
 * @创建时间: 2024-09-20 15:32:23
 */
<template>
    <div class="page_container">
        首页
    </div>
</template>
<script>

export default {
    name: 'Index',
    data () {
        return {

        }
    },
    mounted () {

    },
    methods: {},
    components: {}
}
</script>

<style lang="scss" scoped>
</style>
